import { h } from '@stencil/core';
import { SVGOpts } from '../../../common/images/icons-opts';

export const RatingStarFull = (opts?: SVGOpts) => (
  <svg
    class={opts?.class}
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.874 7.2558L8.13621 7.21834L8.25252 6.98037L11.1689 1.01295C11.5208 0.312773 12.5128 0.347456 12.8281 1.00691L12.8281 1.00693L12.8313 1.01344L15.7937 6.98309L15.9104 7.21834L16.1704 7.25573L22.7187 8.19759C22.7194 8.1977 22.7202 8.19781 22.7209 8.19793C23.4585 8.31313 23.7825 9.23806 23.2057 9.81698C23.2052 9.81749 23.2047 9.81799 23.2042 9.8185L18.4948 14.4382L18.3076 14.6218L18.3522 14.8801L19.4734 21.3834C19.5877 22.147 18.7542 22.732 18.0901 22.3869C18.0897 22.3867 18.0892 22.3865 18.0887 22.3862L12.2569 19.2908L12.0233 19.1669L11.7894 19.2901L5.91128 22.3862C5.91099 22.3864 5.9107 22.3865 5.9104 22.3867C5.24621 22.7323 4.41229 22.1472 4.52657 21.3835L5.64783 14.8801L5.69237 14.6218L5.50524 14.4382L0.794244 9.81696C0.217598 9.23811 0.54146 8.31333 1.27886 8.19797L7.874 7.2558Z"
      fill="#F599BF"
      stroke="#F599BF"
    />
  </svg>
);
